import * as React from "react";
import {
  getGap,
  getRounded,
  getTestimonialImageSize,
} from "@/utils/theme-helper";
import Card from "./Card";

export interface TestimonyListComponentProps {
  imageWidth: string;
  imageIsRectangle: boolean;
  rounded?: string;
  gap?: string;
  items: {
    subTitle: string;
    imageUrl: string;
    title: string;
    content: string;
    hideQuote: boolean;
  }[];
}

const TestimonyListComponent: React.FC<{
  config: TestimonyListComponentProps;
}> = ({ config }) => {
  return (
    <div
      className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 ${getGap(config.gap, "md | lg")}`}
    >
      {config.items.map((item, index) => (
        <Card
          key={`testimonial-${index}`}
          className={`flex ${getRounded(config.rounded)} overflow-hidden`}
        >
          <div className="flex flex-col place-items-center homepage-text-sm flex-1">
            <div className="flex flex-col pt-8 items-center h-40">
              <div role="introTitle" className="text-header-level-3">
                {item.subTitle}
              </div>
              <div
                role="title"
                className="uppercase homepage-text-lg px-4 text-center"
              >
                {item.title}
              </div>
            </div>
            <div className="relative flex flex-1 w-full">
              <div className="absolute flex flex-row justify-between items-center w-full px-4 -top-[60px]">
                <div className="text-[var(--testimony-quote-color)]">
                  {!item.hideQuote && (
                    <svg
                      className="size-14"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 448 512"
                    >
                      <path
                        fill="currentColor"
                        d="M0 216C0 149.7 53.7 96 120 96l8 0 32 0 0 64-32 0-8 0c-30.9 0-56 25.1-56 56l0 8 128 0 0 192L0 416l0-96 0-96 0-8zm256 0c0-66.3 53.7-120 120-120l8 0 32 0 0 64-32 0-8 0c-30.9 0-56 25.1-56 56l0 8 128 0 0 192-192 0 0-96 0-96 0-8z"
                      />
                    </svg>
                  )}
                </div>
                <div
                  style={{
                    width: getTestimonialImageSize(config.imageWidth),
                  }}
                  className="flex flex-col place-items-center"
                >
                  <img
                    className={`${config.imageIsRectangle ? "aspect-square" : "rounded-full aspect-square"} bg-[var(--testimony-image-bg-color)] object-cover border-4 border-transparent w-[120px] h-[120px]`}
                    src={item.imageUrl}
                    alt={item.title}
                  />
                </div>
                <div className="text-[var(--testimony-quote-color)]">
                  {!item.hideQuote && (
                    <svg
                      className="size-14"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 448 512"
                    >
                      <path
                        fill="currentColor"
                        d="M192 296c0 66.3-53.7 120-120 120l-8 0-32 0 0-64 32 0 8 0c30.9 0 56-25.1 56-56l0-8L0 288 0 96l192 0 0 96 0 96 0 8zm256 0c0 66.3-53.7 120-120 120l-8 0-32 0 0-64 32 0 8 0c30.9 0 56-25.1 56-56l0-8-128 0 0-192 192 0 0 96 0 96 0 8z"
                      />
                    </svg>
                  )}
                </div>
              </div>
              <div
                dangerouslySetInnerHTML={{ __html: item.content }}
                className="pt-[100px] p-8 bg-[var(--testimony-bg-color)] text-[var(--testimony-text-color)] text-center flex-1"
              ></div>
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
};

export default TestimonyListComponent;
